import styled from "styled-components";

export const Cabecalho = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 2px;

  /* Na exportação (imagem/PDF) o botão de recolher não deve aparecer. */
  body[data-export-mode="true"] & {
    display: none;
  }
`;

export const ToggleBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textSecondary};
  cursor: pointer;
  transition: color 0.16s ease, border-color 0.16s ease, background 0.16s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: ${({ theme }) => theme.accent};
    border-color: ${({ theme }) => theme.accent};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }
`;

export const ColapsadoStrip = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding-top: 2px;
`;

export const RotuloVertical = styled.span`
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textSecondary};
  white-space: nowrap;
`;
